import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import {WarehouseServiceProvider} from '../../../providers/wh/warehouse-service';
import { ParcelListPage } from '../parcels_list/index';

@Component({
  selector: 'page-list',
  templateUrl: 'index.html',
  providers: [WarehouseServiceProvider]
})
export class WhIndexPage {
 header_data:any;

  d: any; r: string;

pet:any;
dashboard_data:any="";
  public drivers_list: any;
  objectKeys = Object.keys;
  constructor(public navCtrl: NavController, public navParams: NavParams,public warehouseService: WarehouseServiceProvider,public loadingCtrl: LoadingController) {
    this.header_data={ismenu:true,ishome:false,title:"FODEL Driver Manager"};
   
    this.load_dashboard_data();
  }


  load_dashboard_data()
  {
 



  let loader = this.loadingCtrl.create({
      content: "Please wait..."
    });
    loader.present();



        this.warehouseService.load_dashboard_deta()
        .then(data => {
          this.dashboard_data = data;
          //console.log(this.dashboard_data);
           this.pet = "0";
        });
        loader.dismiss();

  }
  
      
    openDriverParcels(driver_object) {
           console.log('Driver  Object');

           driver_object.page_title="Driver ";
           driver_object.name=driver_object.driver_name;

                 console.log(driver_object);
           this.navCtrl.push(ParcelListPage,driver_object);
  }


    openClientParcels(client_object) {

           console.log('Client Object');
           client_object.page_title="Client ";
           client_object.name=client_object.client_name;
          client_object.data={'Current Stock List':client_object.client_data};
                 console.log(client_object);
           this.navCtrl.push(ParcelListPage,client_object);
  }




}



// WEBPACK FOOTER //
// ./src/pages/wh/index/index.ts